module.exports = __webpack_public_path__ + "img/LogoEvascopes.2d7032d7.png";